import Vuex from "vuex";

export default new Vuex.Store({
  state: {
    sidebar: {
      open: localStorage.getItem("sidebar_open") !== null ? JSON.parse(localStorage.getItem("sidebar_open")) : true,
      drawer: localStorage.getItem("sidebar_drawer") !== null ? JSON.parse(localStorage.getItem("sidebar_drawer")) : true,
    },
    config: {
      items_per_page: 50,
    },
    logo: localStorage.getItem("logo"),
    asn_filters: { }
  },
  mutations: {
    setOpenSidebar: function (state, payload) {
      if (payload.open != undefined) {
        state.sidebar.open = payload.open;
        localStorage.setItem("sidebar_open", JSON.stringify(payload.open));
      }
      if (payload.drawer != undefined) {
        state.sidebar.drawer = payload.drawer;
        localStorage.setItem("sidebar_drawer", JSON.stringify(payload.drawer));
      }
    },
    setLogo: function (state, payload) {
      state.logo = payload;
      localStorage.setItem("logo", payload);
    },
    setAsnFilters: function (state, payload) {
      state.asn_filters = payload;
    }
  },
  actions: {},
  modules: {},
});
